import React from 'react';
import { useSelector } from 'react-redux';

import { cx } from '@travel/utils';

import BannerCampaign from 'components/BannerCampaign';

import { getValidCampaignsForLocations } from 'store/campaign/selectors';

import type { Location } from 'Campaign-Types';

import styles from './campaignManager.module.scss';

export type CampaignManagerProps = {
  location: Location;
  pageType: string;
  siteSection: string;
  pageName: string;
};

function CampaignManager(props: CampaignManagerProps) {
  const { location, pageType, siteSection, pageName } = props;
  const campaigns = useSelector(getValidCampaignsForLocations([location]));
  const isTopPage = location === 'top_page';
  const isReservationListPage = location === 'upcoming_reservation';
  const isBookingStep3 = location === 'booking_step_3';
  const hasCampaigns = campaigns.length > 0;
  const classNames = cx(
    hasCampaigns && isReservationListPage && styles.onReservationPage,
    hasCampaigns && isTopPage && styles.onTopPage,
  );
  const itemClassName = cx(
    isReservationListPage && styles.reservationItems,
    isTopPage && styles.topItems,
    isBookingStep3 && styles.bookingItems,
  );
  return (
    <div className={classNames}>
      {campaigns.map(campaign => {
        switch (campaign.type) {
          case 'banner':
            return (
              <div className={itemClassName}>
                <BannerCampaign
                  location={location}
                  pageType={pageType}
                  siteSection={siteSection}
                  pageName={pageName}
                  campaignData={campaign.content}
                  campaignMeta={campaign.meta}
                />
              </div>
            );
        }
      })}
    </div>
  );
}

export default CampaignManager;
